import { render } from "./DropZone.vue?vue&type=template&id=82686a2c&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=ts"
export * from "./DropZone.vue?vue&type=script&lang=ts"

import "./DropZone.vue?vue&type=style&index=0&id=82686a2c&lang=less&scoped=true"
import "./DropZone.vue?vue&type=style&index=1&id=82686a2c&lang=css"
script.render = render
script.__scopeId = "data-v-82686a2c"

export default script